<div class="questionnaire-testarea-layout">
  <textarea name="questionnaire-testarea" maxlength="300" (blur)="textareaBlur()" (focus)="textareaFocus()"></textarea>
  <div class="questionnaire-testarea-placeholder" *ngIf="selectedTag === ''&&isShowPlaceholder" (click)="closePlaceholder()">{{placeholder}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-textarea/questionnaire-textarea.component.html